module.exports = __webpack_public_path__ + "img/organizations.65ccb43b.png";